import PropTypes, { InferProps } from 'prop-types';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//import PloniWoff2 from 'assets/fonts/ploni-regular-aaa.woff2';
import rtlPlugin from 'stylis-plugin-rtl';
import palette from './palette';
import { typography } from './typography';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

ThemeProvider.propTypes = {
  children: PropTypes.node,
  dir: PropTypes.string,
};

const sizes = {
  DRAWER_WIDTH: 256,
  DRAWER_WIDTH_CLOSED: 62,
  APPBAR_MOBILE: 68,
  APP_BAR_DESKTOP: 92,
  CONTAINER_WIDTH: 1366,
  INPUT_HIGHT: 56,
};

declare module '@mui/material/styles' {
  interface CustomTheme {
    sizes: {
      DRAWER_WIDTH: number;
      DRAWER_WIDTH_CLOSED: number;
      APPBAR_MOBILE: number;
      APP_BAR_DESKTOP: number;
      CONTAINER_WIDTH: number;
      INPUT_HIGHT: number;
    };
  }

  interface Theme extends CustomTheme { }
  interface ThemeOptions extends CustomTheme { }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    boldBody1: true;
    boldBody2: true;
    body3: true;
    body4: true;
    boldBody17: true;
    boldBody18: true;
    h3_5: true;
    semiCaption: true;
    captionRegular: true;
    semiCaptionRegular: true;
    boldMedium: true;
    lightSmall: true;
    boldLarge: true;
    boldSmall: true;
    alertBody: true;
    h4_bold: true;
    h4_light: true;
    body5: true;
  }
}
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function ThemeProvider({ children, dir }: InferProps<typeof ThemeProvider.propTypes>) {
  const theme = createTheme({
    palette,
    typography,
    shape: { borderRadius: 8 },
    sizes,
    components: {
      MuiFormGroup: {
        styleOverrides: {
          root: {
            '& .fieldGroup-row .MuiBox-root': {
              width: '100%',
              '& .MuiInputBase-root': {
                width: '100%',
              },
            },
          },
        },
      },
    },
  });

  return dir === 'rtl' ? (
    <StyledEngineProvider injectFirst>
      <CacheProvider value={cacheRtl}>
        <MUIThemeProvider theme={theme}>
          <>
            <CssBaseline />
            {children}
          </>
        </MUIThemeProvider>
      </CacheProvider>
    </StyledEngineProvider>
  ) : (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <>
          <CssBaseline />
          {children}
        </>
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
